require("jquery")
import 'chosen-js'
import '../stylesheets/bootstrap4_chosen.min'

const autocompleter = {
  init(){
    // select.chosen-select[data-placeholder]
    autocompleter.initChosen()
    // select[data-children-select][data-on-change-url]
    autocompleter.initChildrenSelect()
    // select#shop_main_category_ids[data-category-tags-url]
    // select#event_main_category_ids[data-category-tags-url]
    autocompleter.initCategoryTags();
  },
  initChosen() {
    $('.chosen-select').chosen({
      allow_single_deselect: true,
      no_results_text: "Sin resultados para",
      placeholder_text_single: $(this).data('placeholder') || ' ',
      placeholder_text_multiple: $(this).data('placeholder') || ' '
    })
    document.querySelectorAll('.chosen-select.is-invalid').forEach(select => {
      select.nextSibling.classList.add('is-invalid')
    })
  },
  initChildrenSelect() {
    $("select[data-children-select]").each(function(){
      let select = this
      if ($(select).val() === null) {
        autocompleter.getChildren(select);
      }
      $(select).on('change', function(e){
        autocompleter.getChildren(select)
      });
    });
  },
  initCategoryTags(){
    let selectElem = "select[id*=_main_category_ids]"
    if ($(selectElem).length > 0) {
      autocompleter.getCategoryTags(selectElem);
      $(selectElem).on('change', function(e){
        autocompleter.getCategoryTags(selectElem)
      });  
    }
  },
  getCategoryTags(select){
    let tagsElem = "[id*=_tag_ids_fields]"
    if ($(select).val()){
      $.ajax({
        url: $(select).data('categoryTagsUrl'),
        data: {q: {category_tags_category_id_in: $(select).val()}}
      }).done(function(data) {
        $(tagsElem).html(data);
      }).fail(function(data) {
        alert('Error cargando el listado. Vuelve a intentarlo pasados unos segundos.')
      });  
    }
  },
  getChildren(select){
    let children_select = $('#' + $(select).data('children-select'));
    $.ajax({
      url: $(select).data('onChangeUrl'),
      // parent_id_in
      data: {q: {parent_id_or_parent_parent_id_in: $(select).val()}}
    }).done(function(data) {
      // preverve previous selection if posible
      let selected = $(children_select).val()
      $(children_select).html(data).val(selected).trigger("chosen:updated");
    }).fail(function(data) {
      alert('Error cargando el listado. Vuelve a intentarlo pasados unos segundos.')
    });
  },
}

export default autocompleter
